import { render, staticRenderFns } from "./WorkbenchPage.vue?vue&type=template&id=055f4cd6&scoped=true"
import script from "./WorkbenchPage.vue?vue&type=script&lang=js"
export * from "./WorkbenchPage.vue?vue&type=script&lang=js"
import style0 from "./WorkbenchPage.vue?vue&type=style&index=0&id=055f4cd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055f4cd6",
  null
  
)

export default component.exports